import { useId } from 'react'

const CategoryHeading = ({ title, description }) => {
  const headingId = useId()
  
  return (
    <div className="w-full mb-4">
      <h1
        id={headingId}
        className="text-3xl font-bold tracking-tight text-left lg:text-4xl"
      >
        {title}
      </h1>
      {description && (
        <div className="mt-2.5 max-w-xl text-lg text-neutral-500">
          {description}
        </div>
      )}
    </div>
  )
}

export default CategoryHeading
